import React from 'react';
import { JotBillIcon } from '@jotpsych/ui/icons/JotBillIcon';
import { Box, Tooltip } from '@mui/material';

import type { EncounterIdentityBadge } from './types';

export interface EncounterIdentityBadgesProps {
  badges?: EncounterIdentityBadge[] | null;
  size?: number;
}

function isJotBillBadge(badge: EncounterIdentityBadge) {
  return badge.icon === 'jotbill' || badge.key === 'jotbill';
}

function EncounterIdentityBadgeIcon({
  badge,
  size,
}: {
  badge: EncounterIdentityBadge;
  size: number;
}) {
  if (isJotBillBadge(badge)) {
    return (
      <JotBillIcon
        aria-label={badge.label}
        fontSize="small"
        sx={{ width: size, height: size }}
      />
    );
  }

  return null;
}

export function EncounterIdentityBadges({
  badges,
  size = 16,
}: EncounterIdentityBadgesProps) {
  const visibleBadges = badges?.filter(badge => isJotBillBadge(badge)) ?? [];

  if (!visibleBadges.length) {
    return null;
  }

  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>
      {visibleBadges.map(badge => (
        <Tooltip key={badge.key} title={badge.tooltip ?? badge.label} placement="top" arrow>
          <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
            <EncounterIdentityBadgeIcon badge={badge} size={size} />
          </Box>
        </Tooltip>
      ))}
    </Box>
  );
}
